import client, { unwrap } from "./client"

// The synthetic "Other" option the native sheet appends to the server list.
export const OTHER_OPTION_ID = "8"

// Built on its own so the outbox can replay exactly the same request later.
export function flagIssueRequest({ menuItemId, commentId, customComment }) {
  return {
    method: "post",
    url: "/weekly/question-comments/",
    data: {
      menu_item_id: menuItemId,
      comment_id: commentId === OTHER_OPTION_ID ? null : commentId,
      custom_comment: customComment
    }
  }
}

export async function submitFlagIssue(flag) {
  const response = await client.request(flagIssueRequest(flag))
  return unwrap(response) ?? {}
}
